import type { ThemePayload } from "../schemas/Theme";
import { findContrastColor } from "./helpers/findContrastColor";
import { themeCalloutBackground } from "./themeCalloutBackground";

export function themeCalloutText(theme: ThemePayload) {
  return findContrastColor(themeCalloutBackground(theme));
}
